import { useEffect, useState, useCallback } from "react";
import {
  Typography,
  Stack,
  Button,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconFile } from "../../images/iconFile.svg";

import ExportIcon from "../../images/iconExport.svg";

import { useParams } from "react-router-dom";
import api from "../../services/api";

import { dadosIniciais } from "./dadosIniciais";
import ExibirRespostasSalvas from "./exibirRespostasSalvas";
import ExibirMedicamentosSalvos from "./exibirMedicamentosSalvos";
import DetalhesExames from "../../components/DetalhesExames";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import Loading from "../../components/Loading";
import Header from "./modulosReadOnly/Header";
import AnamneseNeurologica from "./modulosReadOnly/AnamneseNeurologica";
import ExameNeurologico from "./modulosReadOnly/Exameneurologico";
import AnamneseGeral from "./modulosReadOnly/AnamneseGeral";
import ExamesProcedimentos from "./modulosReadOnly/ExamesProcedimentos";
import ClassificacaoELA from "./modulosReadOnly/ClassificacaoELA";
import PrescricaoMedicamentos from "./modulosReadOnly/PrescricaoMedicamentos";
import Condutas from "./modulosReadOnly/Condutas";
import Item from "./modulosReadOnly/Item";
import index from "../../components/gerarPDF/index";
import { getItemDecrypt } from "../../utils/cryptoData";
import ModalDialogs from "../../components/ModalDialogs";
import { createFileTxt } from "../../utils/createFileQuerySummary";

import "./styles.css";

export default function ResumoConsulta() {
  const { id } = useParams();
  const [tabAnamnese, setTabAnamnese] = useState(0);
  const [tabExameNeurologico, setTabExameNeurologico] = useState(0);
  const [medicamentosSalvos, setMedicamentosSalvos] = useState([]);
  const [examesSalvos, setExamesSalvos] = useState([]);
  const [examesOutros, setExamesOutros] = useState({
    solicitacaoOutrosExames: [],
  });
  const [dadosDetalhesConsulta, setDadosDetalhesConsulta] = useState({});
  const [loading, setLoading] = useState(true);
  const [profissionalEhNeurologista, setProfissionalEhNeurologista] =
    useState(true);
  const [open, setOpen] = useState(false);
  const [detalhesExamesSelecionados, setDetalhesExamesSelecionados] = useState(
    {}
  );
  const [tabExamesProcedimentos, setTabExamesProcedimentos] = useState(0);
  const vinculo = getItemDecrypt("vinculo_ativo");

  const [openModal, setOpenModal] = useState(false);

  const [exportSelected, setExportSelected] = useState({
    anamneseGeral: false,
    anamneseNeurologica: false,
    classificacaoELA: false,
    condutas: false,
  });

  const handleExportSelected = useCallback((event) => {
    setExportSelected((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.checked,
    }));
  }, []);

  const handleDownload = () => {
    // Conteúdo do arquivo
    createFileTxt(id, dadosDetalhesConsulta, dadosIniciais, exportSelected);
  };

  const handleOpenDetalhesExames = (exame) => {
    setDetalhesExamesSelecionados(exame);
    setOpen(true);
  };

  useEffect(() => {
    fecthData();
  }, []);

  async function fecthData() {
    try {
      setLoading(true);
      await Promise.all([
        detalhesConsulta(),
        getRespostasConsulta(),
        getMedicamentosConsulta(),
        getExamesConsulta(),
        getRespostasOutherExams(),
      ]);
      setProfissionalEhNeurologista(vinculo.perfil.id === 4);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    } finally {
      setLoading(false);
    }
  }

  async function getRespostasConsulta() {
    try {
      const { data } = await api.post("respostas-consulta", {
        id_consulta_evolucao: id,
      });

      ExibirRespostasSalvas(data, dadosIniciais);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getMedicamentosConsulta() {
    try {
      const { data } = await api.post(`medicamentos-consulta/`, {
        id_consulta_evolucao: id,
      });

      if (data.length !== 0) {
        const medicamentos = ExibirMedicamentosSalvos(data);
        setMedicamentosSalvos(medicamentos);
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const getRespostasOutherExams = async () => {
    const response = await api.get(`/outros-exames/${id}`);
    if (response.data) {
      const solicitacaoOutrosExames = response.data.map((item) => {
        return {
          tipoExame: item.no_tipo_exame,
          modeloExame: item.no_modelo_exame,
          descricaoSolicitacaoExame: item.no_descricao_exame.replace(
            /\r\n|\r/g,
            "\n"
          ),
        };
      });
      setExamesOutros({
        solicitacaoOutrosExames: solicitacaoOutrosExames,
      });
    }
  };

  async function getExamesConsulta() {
    try {
      const { data } = await api.post(`exames-consulta/`, {
        id_consulta_evolucao: id,
      });

      if (data.length !== 0) {
        setExamesSalvos(data);
      }
      return data;
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function detalhesConsulta() {
    try {
      const { data } = await api.get(`detalhes-consulta/${id}`);
      setDadosDetalhesConsulta(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const handleOnChangeTab = (value) => {
    setTabExamesProcedimentos(value);
  };

  const handleClosedModal = useCallback(() => {
    setOpenModal(false);
    setExportSelected({
      anamneseGeral: false,
      anamneseNeurologica: false,
      classificacaoELA: false,
      condutas: false,
    });
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box sx={{ mb: 10 }}>
      <Box id="resumoConsulta">
        <Stack
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignContent={"center"}
          alignItems={"center"}
          mb={1}
        >
          <ButtonGoBack />

          <Button
            onClick={() => setOpenModal(true)}
            variant="outlined"
            style={{
              height: "40px",
              textTransform: "none",
              fontSize: "1rem",
              color: "#1E729F",
              borderColor: "#1E729F",
              padding: "0px 10px",
            }}
            startIcon={<img src={ExportIcon} alt="ícone exportar" />}
          >
            Exportar
          </Button>
        </Stack>

        <Header
          dadosDetalhesConsulta={dadosDetalhesConsulta}
          EhNeurologista={profissionalEhNeurologista}
        />

        <AnamneseGeral data={dadosIniciais} />

        {!profissionalEhNeurologista ? (
          <>
            <Accordion defaultExpanded={false} className="AccordionContainer">
              <AccordionSummary
                expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
                aria-controls="ExameNeurologico-content"
                id="ExameNeurologico-header"
                className="AccordionSummaryContainer"
              >
                <Stack
                  direction="row"
                  alignItems="center"
                  gap="8px "
                  height="30px"
                >
                  <IconFile style={{ width: "24px" }} />
                  <Typography className="Accordion_title">
                    Avaliação/Reavaliação
                  </Typography>
                </Stack>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className="section-title">Anamnese</Typography>
                <Typography mb="15px" className="item-text color-blue-dark">
                  {dadosIniciais?.anamnese ?? ""}
                </Typography>

                <Typography className="section-title">
                  Sintomas e queixas
                </Typography>
                <Typography mb="15px" className="item-text color-blue-dark">
                  {dadosIniciais?.sintomasEQueixas ?? ""}
                </Typography>
              </AccordionDetails>
            </Accordion>

            <ExamesProcedimentos
              data={examesSalvos}
              examesOutros={examesOutros}
              onChangeTab={handleOnChangeTab}
              tabValue={tabExamesProcedimentos}
              handleOpenDetalhesExames={handleOpenDetalhesExames}
            />

            <Condutas data={dadosIniciais} />
          </>
        ) : (
          <>
            <AnamneseNeurologica
              tabValue={tabAnamnese}
              tabOnChange={(e, value) => setTabAnamnese(value)}
              data={dadosIniciais}
            />
            <ExameNeurologico
              tabValue={tabExameNeurologico}
              tabOnChange={(e, value) => setTabExameNeurologico(value)}
              data={dadosIniciais}
            />
            <ExamesProcedimentos
              data={examesSalvos}
              examesOutros={examesOutros}
              onChangeTab={handleOnChangeTab}
              tabValue={tabExamesProcedimentos}
              handleOpenDetalhesExames={handleOpenDetalhesExames}
            />
            <ClassificacaoELA data={dadosIniciais} />

            <PrescricaoMedicamentos data={medicamentosSalvos} />
            <Condutas data={dadosIniciais} />
          </>
        )}
        {open && (
          <DetalhesExames
            open={open}
            setOpen={setOpen}
            id_vinculo={vinculo.id}
            id_consulta_evolucao={id}
            detalhesExamesSelecionados={detalhesExamesSelecionados}
            getExamesConsulta={getExamesConsulta}
          />
        )}
      </Box>
      <ModalDialogs
        open={openModal}
        title="Exportar"
        modalType="null"
        onClose={handleClosedModal}
        onActionPrimary={handleDownload}
        primaryButtonText="Exportar"
        secondaryButtonText="Cancelar"
        onActionSecondary={handleClosedModal}
        maxWidth="600px"
        body={
          <Stack
            sx={{
              width: { xs: "100%", sm: "550px" },
              height: "100%",
              textAlign: "start",
              gap: 1,
            }}
          >
            <Typography variant="h5" fontWeight={600} component="h5">
              Quais dados você deseja exportar?
            </Typography>
            <FormGroup>
              <FormControlLabel
                onChange={handleExportSelected}
                control={
                  <Checkbox
                    name="anamneseGeral"
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Anamnese geral"
              />
              <FormControlLabel
                onChange={handleExportSelected}
                control={
                  <Checkbox
                    name="anamneseNeurologica"
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Anamnese neurológica"
              />

              <FormControlLabel
                onChange={handleExportSelected}
                control={
                  <Checkbox
                    name="classificacaoELA"
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Classificação da ELA"
              />
              <FormControlLabel
                onChange={handleExportSelected}
                control={
                  <Checkbox
                    name="condutas"
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                label="Condutas"
              />
            </FormGroup>
          </Stack>
        }
      />
    </Box>
  );
}
